import { SVGProps } from 'react';

export const SidebarCollapsedIcon = (props: SVGProps<any>) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_401_319)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.25 2C3.45507 2 2 3.45507 2 5.25V12.25C2 14.0449 3.45507 15.5 5.25 15.5H12.25C14.0449 15.5 15.5 14.0449 15.5 12.25V5.25C15.5 3.45507 14.0449 2 12.25 2H5.25ZM3.5 5.25C3.5 4.2835 4.2835 3.5 5.25 3.5H10.2V14H5.25C4.2835 14 3.5 13.2165 3.5 12.25V5.25ZM11.7 14H12.25C13.2165 14 14 13.2165 14 12.25V5.25C14 4.2835 13.2165 3.5 12.25 3.5H11.7V14ZM8.53033 10.7803C8.82322 10.4874 8.82322 10.0126 8.53033 9.71967L7.56066 8.75L8.53033 7.78033C8.82322 7.48744 8.82322 7.01256 8.53033 6.71967C8.23744 6.42678 7.76256 6.42678 7.46967 6.71967L5.96967 8.21967C5.67678 8.51256 5.67678 8.98744 5.96967 9.28033L7.46967 10.7803C7.76256 11.0732 8.23744 11.0732 8.53033 10.7803Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_401_319">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
